import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    userid: "",
    username: "",
    password: "",
    isLoggedIn: false,
    favMovies: [],
};

const userSlice = createSlice({
    name: 'user',
    initialState,
    reducers: {
        login: (state, action) => {
            state.userid = action.payload.userid
            state.username = action.payload.username;
            state.password = action.payload.password;
            state.isLoggedIn = true;
        },
        userFavMovies: (state, action) => {
            state.favMovies = action.payload.favMovies;
        },
        logout: (state) => {
            return initialState;
        }
    },
});

export const { login, userFavMovies, logout } = userSlice.actions;
export default userSlice.reducer;